<template>
    <div>
        <v-app-bar-nav-icon  class="show_drawler_fix" @click="showDrawler = !showDrawler"></v-app-bar-nav-icon>
        <v-navigation-drawer dark app temporary v-model="showDrawler">
            <span class="brand-logo brand-logo-drawler"><img src="/images/logo.png"/></span>
            <v-dialog
                v-if="!nospace"
                v-model="dialog"
                width="500"
                dark
                overlay-opacity=".5"
                overlay-color="#333"
            >
                <template v-slot:activator="{ on, attrs }">
                  No add project
<!--                    <v-btn v-bind="attrs" v-on="on" class="waves-effect waves-light btn add_project">Add Project</v-btn>-->
                </template>
                <v-card>
                    <v-card-title class="headline dark justify-center">
                        Please, enter information about project
                    </v-card-title>
                    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="addNewProject">
                        <v-card-text>
                            <v-col cols="12">
                                <v-text-field v-model="newProjectName" :rules="nameRules" label="Project Name" hint="Please enter project name" required></v-text-field>
                                <v-textarea label="Project Description" hint="Please enter project description" type="text" v-model="newProjectDescription"></v-textarea>
                            </v-col>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions >
                            <v-spacer></v-spacer>
                            <v-btn type="submit" color="teofly_orange" text dark >Add Project</v-btn>
                            <v-btn color="grey" text dark @click="dialog = false">Cancel</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-list class="teofly_drawler">
                <v-list-group
                    v-for="item in projects"
                    :key="item.hashid"
                    v-model="item.active"
                    @click="loadingLayerDefault(item.hashid)"
                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.name"><span  class="badge teofly_share"><i class="material-icons">share</i></span></v-list-item-title>
                            <v-list-item-subtitle v-if="(item.is_shared == 1 && item.shared_password == null)"><i title="Shared" class="v-icon mdi mdi-link teofly-color"></i></v-list-item-subtitle>
                            <v-list-item-subtitle v-else-if="(item.is_shared == 1 && item.shared_password != null)"><i title="Shared with Password" class="v-icon mdi mdi-link-lock teofly-color"></i></v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                    <v-list-item
                        v-for="subItem in item.layers"
                        :key="subItem.id"
                        v-model="subItem.active"
                        @click="loadingLayer(item, subItem)"
                        :class="{active : subItem.active}"
                    >
                        <v-list-item-content v-if="reRender">
                            <v-list-item-title v-text="subItem.name"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    name: "ProjectList",
    props:['id', 'showDrawer'],
    data () {
        return {
            dialog: false,
            newProjectName: '',
            newProjectDescription: '',
            valid: false,
            nameRules: [
                v => !!v || 'Name cannot be empty'
            ],
            showDrawler: false,
            reRender: true,
            nospace: false
        }
    },
    computed: {
        projects () {
            return this.$store.getters.projects;
        },
        projectsLoaded(){
            return this.$store.getters.projectsLoaded
        },
        user(){
            return this.$store.getters.user;
        },
        last_project(){
            return this.$store.getters.getLastProject;
        },
        back_layer(){
            return this.$store.getters.back_layer;
        }
    },
    watch: {
        user: function (){
            if (this.user.space_use >= this.user.space_quota) this.nospace = true;
            else this.nospace = false;
        }
    },
    methods:{
        loadingLayerDefault (hashid, new_project = false){
            this.$store.dispatch('setCurrentProject', hashid);
            let prj = this.projects.find(project => project.hashid === hashid);
            for (let layer of prj.layers){
                layer.active = false;
            }
            if (new_project) prj.active = true;

            if (prj.active && prj.layers.length !== 0){

                const key = Object.keys(prj.layers).find(k=>prj.layers[k].id==this.back_layer);
                if (typeof key != 'undefined'){
                    prj.layers[key].active = true;
                }
                else{
                    prj.layers[0].active = true;
                }
                this.reRender = false;
                this.reRender = true;
                if (this.back_layer == 0) this.$store.dispatch('getCurrentLayer', {hashid: hashid, id: prj.layers[0].id});
            }
            else{
                this.reRender = false;
                this.reRender = true;
                this.$store.dispatch('clearCurrentLayer');
            }
        },
        loadingLayer (item, subItem){
            for (let layer of item.layers){
                layer.active = false;
            }
            subItem.active = true;
            this.reRender = false;
            this.reRender = true;
            this.$store.dispatch('getCurrentLayer', {hashid: item.hashid, id: subItem.id});
            this.showDrawler = false;
        },
        addNewProject (){
            if (this.$refs.form.validate()){
                const project = {
                    name: this.newProjectName,
                    description: this.newProjectDescription
                };
                this.$store.dispatch('addNewProject', project)
                .then(() => {
                    this.$refs.form.reset();
                    this.dialog = false;
                    this.$store.dispatch('getProjects')
                    .then(() => {
                        setTimeout(() => {
                            this.loadingLayerDefault(this.last_project.hashid, true);
                        }, 100);
                    })
                })
                .catch(() => {});
            }
        }
    },
    created () {
        if(!this.projectsLoaded){
            this.$store.dispatch('getProjects')
            .then(() => {
                if(this.projects.length != 0){
                    const key = Object.keys(this.projects).find(k=>this.projects[k].hashid===this.id);
                    if (typeof key != 'undefined'){
                        this.projects[key].active = true;
                        this.$store.dispatch('setCurrentProject', this.projects[key].hashid);
                        this.loadingLayerDefault(this.projects[key].hashid);
                    }
                    else{
                        this.projects[0].active = true;
                        this.$store.dispatch('setCurrentProject', this.projects[0].hashid);
                        this.loadingLayerDefault(this.projects[0].hashid);
                        history.pushState({}, null, '/projects/' + this.projects[0].hashid);
                    }
                }
            });
        }
        else if (this.projectsLoaded && this.projects.length != 0){
            const key = Object.keys(this.projects).find(k=>this.projects[k].hashid===this.id);
            if (typeof key != 'undefined'){
                this.projects[key].active = true;
                this.$store.dispatch('setCurrentProject', this.projects[key].hashid);
                this.loadingLayerDefault(this.projects[key].hashid);
            }
            else{
                this.projects[0].active = true;
                this.$store.dispatch('setCurrentProject', this.projects[0].hashid);
                this.loadingLayerDefault(this.projects[0].hashid);
                history.pushState({}, null, '/projects/' + this.projects[0].hashid);
            }
        }
        if (this.user.space_use >= this.user.space_quota) this.nospace = true;
        if (this.showDrawer == 'true') this.showDrawler = true;

    }
};
</script>
